import React, { Component } from 'react';
import PropTypes from "prop-types";
import { TextInput, MaskInput, Checkbox, Modal } from '../index';
import './styles.css';
import kindbody from "../../assets/logos/kindbody.svg";

class BillingForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false
    }
  }

  render() {
    const { fields, cardInfo, errors } = this.props;
    let type = "cardInfo";
    if (!fields) {
      return null;
    }
    let formFields = fields.map((field) => {
      let error = false;
      if (errors.includes(field.field)) {
        error = true
      }
      switch (field.field) {
        case "cardNumber":
          return (
            <MaskInput
              key={field.field}
              error={error}
              value={cardInfo[field.field].value}
              field={field.field}
              label={field.label}
              mask="1111 1111 1111 1111"
              onChange={this._handleInput.bind(this, type, field.field)}
              placeholder="1234 1234 1234 1234"
            />
          )
        case "expDate":
          return (
            <MaskInput
              key={field.field}
              error={error}
              value={cardInfo[field.field].value}
              field={field.field}
              label={field.label}
              mask="11/11"
              onChange={this._handleInput.bind(this, type, field.field)}
              placeholder="mm/yy"
            />
          )
        case "cvc":
          return (
            <MaskInput
              key={field.field}
              error={error}
              value={cardInfo[field.field].value}
              field={field.field}
              label={field.label}
              mask="111"
              onChange={this._handleInput.bind(this, type, field.field)}
              placeholder="123"
            />
          )
        case "cardHolderName":
          return (
            <TextInput
              key={field.field}
              error={error}
              value={cardInfo[field.field].value}
              label={field.label}
              onChange={this._handleInput.bind(this, type, field.field)}
            />
          )
        case "zipCode":
          return (
            <TextInput
              key={field.field}
              error={error}
              value={cardInfo[field.field].value}
              label={field.label}
              onChange={this._handleInput.bind(this, type, field.field)}
              maxLength="5"
            />
          )
        case "membershipTerms":
          return (
            <Checkbox
              key={field.field}
              error={error}
              label={field.label}
              isChecked={cardInfo[field.field].value}
              onChange={this._handleInput.bind(this, type, field.field)}
              modal={this._handleModal.bind(this)}
              modalTrigger="membership terms."
            />
          );
        default:
          return null;
      }
    })

    let modalChildren = (
      <div className="modal__wrapper">
        <img
          className="modal__logo"
          src={kindbody}
          alt="KindBody Logo" />
        <h2 className="modal__title h2">Membership Terms and Conditions</h2>
        <div className="modal__content type__body">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis nec dictum lacus. Suspendisse potenti. Nunc dictum a massa nec rutrum. Suspendisse ac enim et leo consectetur posuere. Curabitur sed urna magna. Aliquam non augue mi. Integer imperdiet mi id ipsum pretium, at scelerisque leo laoreet. Nunc vitae mattis leo. Fusce lacus nulla, ornare ut nisl et, placerat sodales neque. Curabitur vel mattis massa, ac efficitur risus. Sed vulputate arcu non nisi volutpat, eget consectetur eros iaculis. Ut posuere, arcu tristique condimentum convallis, nisl lacus facilisis mauris, quis vehicula neque velit tempus massa. Nam varius eu odio quis ornare.</p>
          <p>Aenean eget turpis urna. Suspendisse lectus mi, fringilla congue ornare id, porttitor in velit. Integer id maximus ligula. Suspendisse tristique sit amet nisl nec placerat. Proin pharetra efficitur orci, at volutpat ligula. In non interdum libero. Vivamus ut mattis arcu. Proin vehicula augue non tellus pharetra ullamcorper. Nulla vitae quam sed enim ultricies iaculis. Cras bibendum vel libero nec euismod.</p>
        </div>
        <button className="modal__button button type__button" onClick={this._handleModalAgree.bind(this)}>I Agree</button>
        <button className="modal__button close button type__button" onClick={this._handleModal.bind(this)}>Close</button>
      </div>
    )

    return (
      <div className="billing-form-wrapper">
        {formFields}
        {this.state.modalOpen ? (
          <Modal
            open={this.state.modalOpen}
            label=" Electronic Communications Consent"
            children={modalChildren}
          />
        ) : null}
      </div>
    )
  }

  // CUSTOM METHOD -------------------------------------
  _handleInput(type, field, e) {
    let value
    if (typeof (e) === "object") {
      if (typeof (e.value) === "string") {
        value = e.value
      } else {
        e.target.type === "checkbox" ? value = e.target.checked : value = e.target.value
      }
    } else {
      value = e
    }
    // console.log(type, field, value)
    this.props.handleInput(type, field, value)
  }

  _handleModal() {
    let isOpen = this.state.modalOpen
    this.setState({ modalOpen: !isOpen })
  }

  _handleModalAgree() {
    this._handleModal()
    this._handleInput("cardInfo", "membershipTerms", true);
  }
};

BillingForm.propTypes = {
  fields: PropTypes.array.isRequired,
  handleInput: PropTypes.func.isRequired,
  cardInfo: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired
}

export default BillingForm


// WEBPACK FOOTER //
// ./src/components/BillingForm/BillingForm.js